import React from 'react';
import { Modal, Button, Box, Typography } from '@drone-js/core';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesErrorButtonClickEventFieldsV2 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ActivitiesErrorButtonClickEventManifestV2 } from '@agoda/analytics-messages-definition-activities/manifest/events';
import { useSelector } from 'react-redux';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';

interface OwnProps {
    showModal: boolean;
    message: string;
    elementName: string;
    /** Default value: <b>true</b> */
    closeOnBackdrop?: boolean;
    buttonText?: string;
    onButtonClick?: () => void;
}

const ErrorModalComponent: React.FC<OwnProps> = React.memo((props) => {
    const cms = useSelector(selectCmsFromBootstrap);
    const onErrorButtonClick = () => {
        trackElementEvent<ActivitiesErrorButtonClickEventFieldsV2>(ActivitiesErrorButtonClickEventManifestV2.ids, {});
        props.onButtonClick && props.onButtonClick();
    };

    return (
        <Modal
            visible={props.showModal}
            data-testid={props.elementName}
            onClose={onErrorButtonClick}
            aria-label={cms[416586]}
            size="s"
            onCloseCompleted={props.closeOnBackdrop === false ? undefined : props.onButtonClick}
        >
            <Box>
                <Typography data-testid="activities-error-message" mb="16" variant="body-default" textAlign="center">
                    {props.message}
                </Typography>
            </Box>
            {props.buttonText && (
                <Button
                    data-testid="activities-error-button"
                    data-element-name="activities-error-button"
                    onClick={onErrorButtonClick}
                    variant="label"
                    hierarchy="primary"
                    size="m"
                    label={props.buttonText}
                />
            )}
        </Modal>
    );
});
ErrorModalComponent.displayName = 'ErrorModalComponent';

export default ErrorModalComponent;
